import React, { useState } from "react";
import Modal from "apollo-react/components/Modal";
import TextInput from "../Form/textInput";
import { Formik, Field } from "formik";
import Typography from "apollo-react/components/Typography";
import "./RejectionReasonModal.css";

const RejectionReasonModal = ({ isOpen, onClose, onConfirm, isProcessing }) => {
  const [rejectionReason, setRejectionReason] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = () => {
    if (!rejectionReason.trim()) {
      setError("Rejection reason is required");
      return;
    }
    onConfirm(rejectionReason);
    setRejectionReason("");
    setError("");
  };

  const handleClose = () => {
    setRejectionReason("");
    setError("");
    onClose();
  };

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      title="Rejection Reason"
      size="medium"
      buttonProps={[
        {
          label: 'Cancel',
          onClick: handleClose,
          disabled: isProcessing
        },
        {
          label: 'Confirm',
          onClick: handleSubmit,
          disabled: isProcessing,
          variant: 'primary',
          status: 'danger'
        }
      ]}
    >
      <div className="rejection-modal-content">
        <Typography
          variant="bodyDefault"
          style={{ marginBottom: "16px", color: "#333" }}
        >
          Please provide a reason for rejecting this request.
        </Typography>
        
        <Formik
          enableReinitialize={true}
          initialValues={{ rejectionReason }}
        >
          <Field name="rejectionReason">
            {({ field, meta }) => (
              <>
                <TextInput
                  {...field}
                  meta={meta}
                  placeholder="Enter the reason for rejection..."
                  value={rejectionReason}
                  onChange={(value) => {
                    setRejectionReason(value);
                    setError("");
                  }}
                  multiline={true}
                  textareaWidth={"100%"}
                  rows={5}
                  disabled={isProcessing}
                />
                {error && (
                  <Typography
                    variant="bodySmall"
                    style={{ color: "#d32f2f", marginBottom: "10px" }}
                  >
                    {error}
                  </Typography>
                )}
              </>
            )}
          </Field>
        </Formik>
      </div>
    </Modal>
  );
};

export default RejectionReasonModal; 